<template>
    <div class="modules">
        <div class="fund-container">
            <div class="summary">
                <h1 class="title">{{ $t("lang.withdrawCrypto") }}</h1>
                <!-- <div class="tools">
                    <el-button size="small">法币提现<i class="el-icon-right"></i></el-button>
                </div> -->
            </div>
            <div class="box-wrapper">
                <div class="box-main">
                    <el-form label-width="100px" label-position="left">
                        <el-form-item >
                            <el-tabs>
                                    <div class="form-item">
                                        <div class="item-label">{{ $t("lang.SendAddress") }}</div>
                                        <div class="item-field">
                                            <el-input v-model="btAddrTo" suffix-icon="el-icon-s-order" :placeholder="$t('lang.SendAddress')" />
                                        </div>
                                    </div>
                                    <div class="form-item">
                                        <div class="item-label">{{ $t("lang.Amount") }}</div>
                                        <div class="item-field">
                                            <el-input v-model="btCoin" @change="changeAmount" suffix-icon="el-icon-s-order" :placeholder="$t('lang.Amount')" />
                                        </div>
                                       <div class="allColor" @click="Withdraw">{{ $t("lang.All") }}</div> 
                                    </div>
                                    <div class="form-item-help">
                                        <div class="meta">
                                            <div class="meta-title">{{ $t("lang.Balance") }}</div>
                                            <div class="meta-val">{{payment.surplusRevoCoinAdvance}} </div>
                                        </div>
                                        <div class="meta">
                                            <div class="meta-title">{{ $t("lang.minimunWithdrawal") }}</div>
                                            <div class="meta-val">{{onceMin}} </div>
                                        </div>
                                        <div class="meta">
                                            <div class="meta-title">{{ $t("lang.premium") }}</div>
                                            <div class="meta-val">{{rateAmount.commission}} </div>
                                        </div>
                                        <div class="meta">
                                            <div class="meta-title">{{ $t("lang.amountReceived") }}</div>
                                            <div class="meta-val">{{rateAmount.btCoin}} </div>
                                        </div>
                                    </div>
                            </el-tabs>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="box-side">
                </div>
            </div>
            <div class="bt">
                <div class="btText">
                    <el-button type="primary" size="medium "  @click="handShow" > <span>{{ $t("lang.withdraw") }}</span>  </el-button>
                </div>
            </div>
            <div class="card">
                <div class="hd">
                    <h2 class="title">{{ $t("lang.WithdrawalHistory") }}</h2>
                </div>
                <div class="bd">
                    <div class="table-wrapper">
                      
                        <div   class="table-inner"   v-loading="tableLoading"   element-loading-spinner="el-icon-loading"  >
                            <el-table :data="dataSource">

                                <el-table-column  :label="$t('lang.amount')" prop="revoCoin" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.revoCoin }}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column :label="$t('lang.premium')" prop="commission" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.commission }}</span>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column :label="$t('lang.gas')" prop="gas" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.gas }}</span>
                                    </template>
                                </el-table-column> -->
                                <el-table-column  :label="$t('lang.amountReceived')" prop="btCoin" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.btCoin }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  :label="$t('lang.SendAddress')" prop="btAddrTo" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.btAddrTo }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  :label="$t('lang.arrived')" prop="tradeStateVal" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.tradeStateVal }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  :label="$t('lang.ReviewTime')"  prop="auditTime" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.auditTime }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  :label="$t('lang.ReviewStatus')" prop="auditStateVal" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.auditStateVal }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  :label="$t('lang.ProcessingStatus')" prop="processStateVal" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.processStateVal }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  :label="$t('lang.ReasonRejection')" prop="auditReason" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.auditReason }}</span>
                                    </template>
                                </el-table-column>
                              
                            </el-table>
                            <div class="pagination">
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="ipagination.pageNo"
                                    :page-size="ipagination.pageSize"
                                    layout="prev, pager, next, jumper"
                                    :total="ipagination.total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <select-network-dialog ref="networkDialog"></select-network-dialog>
        <el-dialog  :visible="showWord"  :title='$t("lang.PasswordVerification")'  :close-on-click-modal="false"  width="650px"  custom-class="nft-dialog"  @close="closeWord"  >
          <div class="nft-dialog-body">
            <div class="top-detail">
              <div class="right-info">
                <div class="row">
                  <div>
                    <span class="value">{{ $t("lang.Amount") }} </span>
                    <img src="./../../assets/img/icon.png" alt="" />
                    <span>{{ btCoin }} {{payment.btUnit}}</span>
                  </div>
                </div>
              </div>
            </div>
            <el-input :placeholder="$t('lang.PleasePassword')" v-model="password" show-password></el-input>
            <div class="Confirm">
              <el-button @click="hand()" :loading="showButtonLoading" round  >{{$t("lang.submit")}}</el-button>
            </div>
          </div>
        </el-dialog>
        <recharge-warning-dial ref="rechargeWarningDial" @close="closeWarn"></recharge-warning-dial>
    </div>
    </template>
    <script>
    import SelectNetworkDialog from './modules/selectNetworkDialog.vue';
    import {BASE_GLOB_API} from "@/config.js";
    import {axiosGet,axiosPost} from '@/api/api';
    import EventBus from '@/utils/EventBus';
    import rechargeWarningDial from "@/components/rechargeWarningDial.vue";
    
    export default {
        name:'payment',
        components:{SelectNetworkDialog, rechargeWarningDial},
        data(){
            return {
                Language: "en",
                form:{},
                url:{
                    coins:BASE_GLOB_API+'/kanban/coin/platform',
                    commissionRate:BASE_GLOB_API+'/withdrawal/commissionRate',
                    apply:BASE_GLOB_API+'/withdrawal/apply',
                    limit:BASE_GLOB_API+'/withdrawal/limit',
                    userInfo:BASE_GLOB_API+'/kanban/wallet/info',
                    list:BASE_GLOB_API+'/withdrawal/page',
                },
                queryParams:{},
                dataSource:[],
                ipagination:{
                    pageNo:1,
                    pageSize:10,
                    total:0
                },
                tableLoading:false,
                lang: "",
                btAddrTo:'',
                btCoin:'',
                btPlatformId:'',
                btPlatformNetworkId:'',
                btPlatformName:'',
                payment:{},
                onceMin:0,
                showWord:false,
                rateAmount:{
                    commission:0,
                    rate:0,
                    btCoin:0,
                    gas:0
                },
                showButtonLoading: false,
                password:'',
                isClick:true,
            }
        },
        created(){
            this.lang = sessionStorage.getItem("Language")
            let selectedNetPc = JSON.parse( sessionStorage.getItem("selectedNetPc"));
            if(selectedNetPc){
                this.btPlatformId = selectedNetPc.btPlatformId
                this.btPlatformNetworkId = selectedNetPc.btPlatformNetworkId
                this.btPlatformName = selectedNetPc.fullName
                this.UserInfo(selectedNetPc.btPlatformId)
                this.initList(1,10)
            }
            EventBus.$on('share', value => {
            // 将 A 组件传递过来的数据保存到 B 组件
                if(value){
                    let selectedNetPc = JSON.parse( sessionStorage.getItem("selectedNetPc"));
                    if(selectedNetPc){
                        this.btPlatformId = selectedNetPc.btPlatformId
                        this.btPlatformNetworkId = selectedNetPc.btPlatformNetworkId
                        this.btPlatformName = selectedNetPc.fullName
                        this.UserInfo(selectedNetPc.btPlatformId)
                        this.initList(1,10)
                    }
                
                }

            })
        },
        mounted(){
           
        },
        methods:{
            closeWarn(){
                this.showWord = true;
            },
            UserInfo(value){
                axiosGet(this.url.userInfo,{btPlatformId:value}).then(res=>{
                   if(res.code ==200){
                    this.payment =res.result
                    this.payLimit(this.payment)
                   }else{
                        this.$message.error(res.message);
                    }
                })
               
            }, 
            Withdraw(){
               this.btCoin = this.payment.surplusRevoCoinAdvance
            },
            payLimit(e){
                let params = {
                    btPlatformId:e.btPlatformId,
                };
                axiosGet(this.url.limit, params).then(res=>{
                    if(res.success){
                      this.onceMin =res.result.onceMin
                    }else{
                        this.$message.error(res.message);
                     
                    }
                }).catch((err)=>{
                    this.$message.error(err);
                   
                })
            },
            closeWord(){
            this.showWord =false
            this.password =""
            },
            handShow(){ //提现逻辑
                if(!this.btAddrTo){
                    this.$message.error(this.$t("lang.addressEmpty"));
                    return;
                 }
                const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/;
                if (!ethAddressRegex.test(this.btAddrTo)) {
                    this.$message.error(this.$t("lang.addressInvalid"));
                    return;
                }
                 if(!this.btCoin){
                    this.$message.error(this.$t("lang.withdrawalEmpty"));
                    return;
                 }
                 if(!this.payment.btPlatformId){
                    this.$message.error(this.$t("lang.platformEmpty"));
                    return;
                 }
                this.$refs.rechargeWarningDial.openDialog(this.btAddrTo, this.$t('lang.withdrawTo') + ":" + this.btPlatformName);
            },
            hand(){
                if(this.isClick) {
                this.isClick = false;
                console.log('我被点击了');
                this.handleNext();
                }else{
                console.log('请勿过快点击');
                }
            },
            handleNext(){
                if(!this.password){
                    this.$message.error(this.$t("lang.PleasePassword"));
                    setTimeout(()=>{ 
                            this.isClick = true;
                        },500)
                    return;
                 }
                this.showButtonLoading = true;
                let params = {
                    btAddrTo:this.btAddrTo,
                    btCoin:this.btCoin,
                    btPlatformId:this.payment.btPlatformId,
                    btPlatformNetworkId:this.btPlatformNetworkId,
                    password:this.password
                };
                axiosPost(this.url.apply, params).then(res=>{
                    if(res.success){
                        this.showButtonLoading = false;
                        setTimeout(()=>{ 
                            this.isClick = true;
                        },500)
                        this.closeWord()
                        this.btAddrTo=''
                        this.btCoin=''
                        this.$message.success(res.message);
                        this.$router.push({name:'dashboard'});
                        EventBus.$emit('router',  3);
                    }else{
                        this.showButtonLoading = false;
                        setTimeout(()=>{ 
                            this.isClick = true;
                        },500)
                        this.password =""
                        this.$message.error(res.message);
                     
                    }
                }).catch((err)=>{
                    this.showButtonLoading = false;
                    this.password =""
                    setTimeout(()=>{ 
                        this.isClick = true;
                    },500)
                    this.$message.error(err);
                   
                })
            },
            changeAmount(e){
                
                // console.log("22222",isNaN(e))
                // console.log("222111",!isNaN(e)&&e&& !(typeof e === 'string') && !(e.trim() === ''))
                if(!isNaN(e)&& !(e.trim() === '')){
                    let params = {
                      btCoin:e,
                      btPlatformId: this.btPlatformId
                   };
                axiosPost(this.url.commissionRate, params).then(res=>{
                    if(res.success){
                      this.rateAmount.commission = res.result.commission
                      this.rateAmount.rate = res.result.rate
                      this.rateAmount.btCoin = res.result.btCoin
                      this.rateAmount.gas = res.result.gas
                    }else{
                        this.$message.error(res.message);
                     
                    }
                }).catch((err)=>{
                    this.$message.error(err);
                   
                })
                }
            },
            openNetworkDialog(){
                this.$refs.networkDialog.open();
            },
            initList(pageNo, pageSize){
                this.tableLoading = true;
                let params = {
                    current:pageNo||1,
                    size:pageSize||10,
                    query:{
                        btPlatformId: this.btPlatformId
                    }
                }
                // params = Object.assign(params, this.queryParams);
                axiosPost(this.url.list, params).then(res=>{
                    this.tableLoading = false;
                    if(res.success){
                        let data = res.result;
                        this.dataSource = data.records;
                        this.ipagination.pageNo = Number(data.current);
                        this.ipagination.pageSize =Number(data.size);
                        this.ipagination.total =Number(data.total);
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                
                this.initList(val, this.ipagination.pageSize);
            },
        }
    }
    </script>
    <style lang="less" scoped>
    .fund-container {
        .summary {
            background:#f4f5f6; border-radius:4px; padding:30px; display:flex; justify-content: space-between; align-items: center; margin-bottom:30px;
        }
        .box-wrapper {
            display:flex; justify-content: space-between; align-items: flex-start;
            .box-main {
                flex:1;
                .form-item {
                  .allColor{
                    color: #4458fe;
                  }
                }
                .form-item-help {
                    display:flex; justify-content: space-between; align-items: flex-start; flex-wrap:wrap; margin:10px -5px;
                    .meta {
                        width:50%; line-height:23px; padding:5px;
                        .meta-title {color:#999;}
                        .meta-val {color:#333; font-weight:700;}
                    }
                }
            }
            .box-side {
                width:300px; min-width:300px; margin-left:50px;
                .mod {
                    .bd {
                        .list {
                            .item {
                                display:flex; justify-content: flex-start; align-items: flex-start; padding:4px 0;
                                .item-icon {
                                    background:url(~@/assets/img/icon_text.svg) no-repeat center center/contain; width:12px; height:12px; margin:4px 6px 0 0;
                                }
                                .item-text {
                                    font-size:14px; color:#666; cursor: pointer;
                                    &:hover {
                                        color:#4458fe; text-decoration: underline; opacity: .8;
                                    }
                                }
                                &.item-video {
                                    .item-icon {
                                        background-image:url(~@/assets/img/icon_video.svg);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .card {
            padding: 30px 0;
            .hd {
                .title {}
            }
            .bd {
                .table-wrapper {
                    padding:10px 0;
                    .table-tools {
                        .table-tabs {
                            display:flex; justify-content: flex-start; align-items: center;
                            .tab-item {
                                line-height:1; padding:8px 14px; border-radius:4px; background:#f4f5f6; margin:0 10px 10px 0; cursor: pointer;
                                &.active, &:hover {
                                    background:#e7eafe; color:#4458fe;
                                }
                            }
                        }
                    }
                    .table-inner{
                        .pagination {
                            padding:15px 0; text-align:right;
                        }
                    }
                }
            }
        }
        .bt{
           display: flex;
           justify-content:space-around; 
           .btText{
            width: 40%;
           }
        }
    }
    .select-option-coin-item {
        display:flex; justify-content: flex-start; align-items: center;
    }
    .select-option-network-item {}
    .el-dialog__body {
        padding: 10px 40px 40px;
        .top-detail {
          display: flex;
          border-bottom: 1px solid #ddd;
          padding-bottom: 20px;
          .left-img {
            width: 53%;
            margin-right: 4%;
            text-align: center;
            img {
              width: 90%;
              border-radius: 10px;
            }
          }
          .right-info {
            width: 90%;
            .row {
              display: flex;
              justify-content: space-between;
              font-size: 16px;
              font-weight: 600;
              & > div {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                margin-bottom: 20px;
                .value {
                  font-weight: 400;
                  margin-right: 10px;
                }
                img {
                  width: 24px;
                  margin: 0 2px;
                }
              }
            }
          }
        }
        .Confirm {
          text-align: center;
          margin-top: 40px;
          .el-button {
            background: #ffdda9;
            border: none;
            &:hover {
              border: none;
              color: #333;
              background: #fad398;
            }
          }
        }
      }
    </style>